module.exports = __webpack_public_path__ + "static/media/firefox.223e1bca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/firefox.png
// module id = 97
// module chunks = 0